import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const agendaService = (() => {
  const axios = require('axios');

  const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // Include cookies in requests
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('jwt-token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  const addAgenda = async (agenda) => {
    try {
      const response = await instance.post('/Agenda', agenda);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
   
  const getAllAgenda = async () => {
    try {
      const response = await instance.get('/Agenda');
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const getById = async (id) => {
    try {
      const response = await instance.get(`/Agenda/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const editAgenda = async (id, agenda) => {
    try {
      const response = await instance.put(`/Agenda/${id}`, agenda);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const removeAgenda = async (id) => {
    try {
      const response = await instance.delete(`/Agenda/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return {
    addAgenda,
    getAllAgenda,
    getById,
    editAgenda,
    removeAgenda
  };
})();

export default agendaService;
